import { IsNotEmpty, MinLength } from 'class-validator';
import i18next from 'i18next';
import type { AuthUser } from './auth-user';

export class LoginRequest {
  @IsNotEmpty({ message: () => i18next.t('auth.validation.usernameRequired') })
  username: string;

  @IsNotEmpty({ message: () => i18next.t('auth.validation.otpRequired') })
  @MinLength(6, { message: () => i18next.t('auth.validation.otpMinLength') })
  otp: string;

  constructor(data?: Partial<LoginRequest>) {
    this.username = data?.username || 'toanhv';
    this.otp = data?.otp || '000000';
  }
}

export interface LoginResponse {
  user: AuthUser;
  accessToken: string;
  refreshToken: string;
  expiredAt: string;
  dnnToken: string | null;
}
